import { observer } from 'mobx-react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator
} from '@components/ui/breadcrumb';
import { Routes } from '../core/routes';
import { injectTSDI } from '../core/tsdi';

export const Breadcrumbs = observer(() => {
    const { getBreadcrumbs } = injectTSDI(Routes);
    const { pathname } = useLocation();
    const crumbs = getBreadcrumbs(pathname);

    return (
        <Breadcrumb>
            <BreadcrumbList>
                {crumbs.map((crumb, index) => {
                    const last = index === crumbs.length - 1;
                    return (
                        <React.Fragment key={crumb.path}>
                            {index > 0 && <BreadcrumbSeparator />}
                            <BreadcrumbItem>
                                {last ? (
                                    <BreadcrumbPage>
                                        {crumb.title}
                                    </BreadcrumbPage>
                                ) : (
                                    <BreadcrumbLink asChild>
                                        <Link to={crumb.path}>
                                            {crumb.title}
                                        </Link>
                                    </BreadcrumbLink>
                                )}
                            </BreadcrumbItem>
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
});
